<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 88px">
      <Loading></Loading>
    </div>
    <v-container
      v-else
      class="Kanit px-5"
      grid-list-xs
      style="padding-bottom: 100px"
    >
      <div>
        <div style="text-align: center; position: relative" class="py-2 mb-3">
          <div
            v-if="$store.state.redirect"
            style="position: absolute; top: 0px; left: 0px"
          >
            <v-btn
              @click="query.view = $store.state.redirect"
              text
              class="pl-0"
            >
              <v-icon class="mr-2">mdi-chevron-left</v-icon>BACK
            </v-btn>
          </div>
          <img style="height: 50%; width: 64px" src="../assets/logo.svg" />
        </div>

        <div class="Kanit">
          <div class="text-center">
            <h3 style="color: #0c4d9d" class="mb-4">แก้ไขที่อยู่</h3>
          </div>
          <ValidationObserver ref="observer" tag="form">
            <form>
              <ValidationProvider
                :name="'รหัสไปรษณีย์'"
                :rules="'required'"
                key="zipcode"
                v-slot="{ errors }"
              >
                <thai-address-input
                  v-model="input.zip_code"
                  type="zipcode"
                  @select="onSelectAddress"
                  :placeholder="`รหัสไปรษณีย์`"
                  :label="`Zipcode`"
                  :error-messages="errors"
                  :hide-details="errors.length == 0"
                ></thai-address-input>
              </ValidationProvider>
              <div style="clear: both"></div>
              <ValidationProvider
                :name="'จังหวัด'"
                :rules="'required'"
                key="province"
                v-slot="{ errors }"
              >
                <thai-address-input
                  v-model="input.province"
                  type="province"
                  :label="`Province`"
                  placeholder="จังหวัด"
                  @select="onSelectAddress"
                  :error-messages="errors"
                  :hide-details="errors.length == 0"
                ></thai-address-input>
              </ValidationProvider>
              <div style="clear: both"></div>

              <ValidationProvider
                :name="'อำเภอ/เขต'"
                :rules="'required'"
                key="amphoe"
                v-slot="{ errors }"
              >
                <thai-address-input
                  v-model="input.sub_district"
                  type="amphoe"
                  :label="`District`"
                  placeholder="อำเภอ/เขต"
                  @select="onSelectAddress"
                  :error-messages="errors"
                  :hide-details="errors.length == 0"
                ></thai-address-input>
              </ValidationProvider>
              <div style="clear: both"></div>
              <ValidationProvider
                :name="'ตำบล/แขวง'"
                :rules="'required'"
                key="district"
                v-slot="{ errors }"
              >
                <thai-address-input
                  v-model="input.district"
                  type="district"
                  :label="'Sub-district'"
                  placeholder="ตำบล/แขวง"
                  @select="onSelectAddress"
                  :error-messages="errors"
                  :hide-details="errors.length == 0"
                ></thai-address-input>
              </ValidationProvider>
              <div style="clear: both"></div>

              <ValidationProvider
                :name="'ที่อยู่'"
                :rules="'required'"
                key="addressno"
                v-slot="{ errors }"
              >
                <v-textarea
                  v-model="input.address1"
                  outlined
                  rows="3"
                  label="Address"
                  class="mb-6"
                  placeholder="ที่อยู่ บ้านเลขที่ หมู่บ้าน ถนน"
                  :error-messages="errors"
                  :hide-details="errors.length == 0"
                ></v-textarea>
              </ValidationProvider>

              <div class="text-center mt-0 mb-4">
                <v-btn
                  @click="editAddress"
                  block
                  :loading="saveloading"
                  dark
                  color="#0c4d9d"
                >
                  <span>แก้ไขที่อยู่</span>
                </v-btn>

                <v-btn text block @click="cancelAddress">ยกเลิก</v-btn>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import UploadFile from "@/components/UploadProfile";
import ThaiAddressInput from "@/components/ThaiAddressInput";
import Loading from "@/components/Loading.vue";
export default {
  data() {
    return {
      isEdit: true,
      loading: true,
      saveloading: false,
      activeAddress: "",
      address: [],
      input: {
        zip_code: "",
        province: "",
        sub_district: "",
        district: "",
        address1: "",
      },
    };
  },
  components: {
    Loading,
    UploadFile,
    ThaiAddressInput,
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
    isCustomerProfile() {
      return this.$store.state.redirect == "CustomerProfile" ? true : false;
    },
  },
  async mounted() {
    await this.checkLoginStatus();
    await this.getUserAddress();
    this.loading = false;
  },
  methods: {
    checkLoginStatus() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toacheckstatuslogincustomer",
            {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: {
                userid: this.$store.state.userid,
                apptype: this.query.apptype,
                pageid: this.query.pageid,
              },
            }
          )
          .then(async (response) => {
            if (response.data.responsecode == 400) {
              this.$store.state.redirect = "CustomerAddress";
              this.query.view = "Agreement";
              resolve();
            } else {
              resolve();
            }
          });
      });
    },
    clickEdit(item) {
      this.isEdit = true;
      Object.assign(this.input, item);
    },
    async addAddress() {
      if (!this.saveloading) {
        var vm = this;
        var data = {
          userid: this.$store.state.userid,
          apptype: this.query.apptype,
          pageid: this.query.pageid,
          ...this.input,
        };
        var isValid = await this.$refs.observer.validate();
        if (isValid) {
          this.saveloading = true;
          axios
            .post(
              "https://communitybotbyzwizai.herokuapp.com/toainfocustomer-createaddress",
              data,
              {
                headers: {
                  AUTHORIZATION: "Bearer xxx xxx",
                },
              }
            )
            .then(async (response) => {
              vm.saveloading = false;

              if (response.data && response.data.responsecode == 400) {
                await vm.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
                return;
              } else if (response.data.responsecode == 200) {
                await vm.$swal.fire({
                  text: "เพิ่มที่อยู่สำเร็จ",
                  icon: "success",
                });
                vm.address = response.data.data;
                vm.activeAddress = vm.address[vm.address.length - 1].id;
                vm.$forceUpdate();
                vm.isEdit = false;
              } else if (response.data.responsecode == 401) {
                await vm.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
                vm.query.view = "Login";
              }
            });
        }
      }
    },
    cancelAddress() {
      this.query.view = this.$store.state.redirect;
    },
    newAddressBtn() {
      this.isEdit = true;
      this.input = {
        zip_code: "",
        province: "",
        sub_district: "",
        district: "",
        address1: "",
      };
    },
    onSelectAddress(address) {
      this.input.sub_district = address.amphoe;
      this.input.district = address.district;
      this.input.province = address.province;
      this.input.zip_code = address.zipcode;
    },
    getUserAddress() {
      var vm = this;
      return new Promise((resolve, reject) => {
        var url = "";
        if (vm.$store.state.redirect == "DealerProfile") {
          url = "toadealeraddress";
        } else {
          url = "toapainteraddress";
        }

        axios
          .get("https://communitybotbyzwizai.herokuapp.com/" + url, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
            params: {
              userid: this.$store.state.userid,
              apptype: this.query.apptype,
              pageid: this.query.pageid,
            },
          })
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              return;
            } else if (
              response.data.responsecode == 200 &&
              response.data.data
            ) {
              if (response.data.data) {
                this.address = response.data.data[0];
                this.input = this.address;
              }
            }
            resolve();
          });
      });
    },
    async editAddress() {
      var vm = this;
      var data = {
        userid: this.$store.state.userid,
        apptype: this.query.apptype,
        pageid: vm.query.pageid,
        ...vm.input,
      };

      var isValid = await this.$refs.observer.validate();
      if (isValid) {
        if (!vm.saveloading) {
          vm.saveloading = true;
          var url = "";
          if (vm.$store.state.redirect == "DealerProfile") {
            url = "toadealeraddress";
          } else {
            url = "toapainteraddress";
          }

          axios
            .put("https://communitybotbyzwizai.herokuapp.com/" + url, data, {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            })
            .then(async (response) => {
              vm.saveloading = false;
              if (response.data && response.data.responsecode == 400) {
                await vm.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
                return;
              } else if (response.data.responsecode == 200) {
                await vm.$swal.fire({
                  text: "แก้ไขที่อยู่สำเร็จ",
                  icon: "success",
                });
                vm.$forceUpdate();
              }
            });
        }
      }
    },
    confirmAddress() {
      var vm = this;
      if (!vm.saveloading) {
        this.saveloading = true;
        var data = {
          userid: this.$store.state.userid,
          apptype: this.query.apptype,
          pageid: this.query.pageid,
          address: this.address.find((el) => el.id == this.activeAddress),
        };
        axios
          .post(
            "https://communitybotbyzwizai.herokuapp.com/toainfocustomer",
            data,
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then(async (response) => {
            this.saveloading = false;
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              return;
            } else if (
              response.data.responsecode == 200 &&
              response.data.data
            ) {
              if (vm.query.apptype == "line") {
                // await vm.$liff.sendMessages([
                //   {
                //     type: "text",
                //     text: "แสดงรายการค้นหา",
                //   },
                // ]);
                if (this.query.apptype == "line") {
                  await this.$liff.closeWindow();
                } else if (this.query.apptype == "facebook") {
                  this.$store.dispatch("messengerClose");
                }
              }
            } else {
              vm.$swal.fire({
                icon: "error",
                text: "ลงทะเบียนไม่สำเร็จ",
              });
            }
          });
      }
    },
  },
};
</script>